import React from "react"
import {
    useConnectWithUsMutation
} from "../Redux/actions/user.action"
import {
    resetForm,
    updateFields
} from "../Redux/actions/formValue.action"
import { useDispatch,useSelector } from "react-redux"
import _ from "lodash"
import { Message, toaster } from "rsuite"
import {Loader} from "../components/index"

const ConnectWithUs = () => {
    const dispatch = useDispatch()
    const [connectUs,connectUsState] = useConnectWithUsMutation()

    const state = useSelector((state)=> state.form)

    React.useEffect(()=> {
        return ()=> {
            dispatch(resetForm())
        }
    },[])
    React.useEffect(()=>{
        if(connectUsState.isSuccess){
            const message = _.get(connectUsState,"data.message","")
            toaster.push(<Message type="success" >{message}</Message>,{placement:"topCenter"})
            connectUsState.reset()
            dispatch(resetForm())
        }
        if(connectUsState.isError){
            const errMessage = _.get(connectUsState,"error.error","Error while Connect! Please try again")
            toaster.push(<Message type="error" >{errMessage}</Message>,{placement:"topCenter"})
            connectUsState.reset()
        }
    },[connectUsState.status])

    function handleSubmit(e){
        e.preventDefault()
        const name = _.get(state,"state.name","")
        const phone_number = _.get(state,"state.phone_number","")
        const email = _.get(state,"state.email","")
        const subject = _.get(state,"state.subject","")
        const message = _.get(state,"state.message","")
        if(!name || !phone_number || !email || !subject || !message){
            toaster.push(<Message type="info" >Please Fill All Fields!</Message>,{placement:"topCenter"})
            return
        }
        const data = {
            name,
            phone_number,
            email,
            subject,
            message
        }
        connectUs(data)
    }
    return (
        <div className="min-h-screen bg-gray-50">
            {/* Hero Section */}
            <div className="bg-gradient-to-r from-blue-600 to-blue-400 text-white py-16 px-4">
                <div className="max-w-6xl mx-auto text-center">
                    <h1 className="text-3xl md:text-4xl font-bold">
                        Connect With Us
                    </h1>
                    <p className="mt-4 text-lg text-blue-100">
                        Have questions? We’re here to help you anytime.
                    </p>
                </div>
            </div>

            {/* Content Section */}
            <div className="max-w-6xl mx-auto px-4 py-12 grid grid-cols-1 md:grid-cols-2 gap-10">
                {/* Left: Contact Info */}
                <div>
                    <h2 className="text-2xl font-semibold mb-6">
                        Get in Touch
                    </h2>

                    <ContactItem
                        title="Email"
                        value="bhubanpadun15m37@gmail.com"
                    />
                    <ContactItem
                        title="Phone"
                        value="+91 93872 20065"
                    />
                    <ContactItem
                        title="Location"
                        value="Assam, Dhemaji, Jonai,787060"
                    />
                </div>

                {/* Right: Contact Form */}
                <div className="bg-white rounded-xl shadow-lg p-6 md:p-8">
                    <h2 className="text-xl font-semibold mb-6">
                        Send us a message
                    </h2>

                    <form className="space-y-4" 
                       onSubmit={handleSubmit}
                    >
                        <input
                            type="text"
                            placeholder="Full Name"
                            className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onChange={(e)=> {
                                const val = e.target.value
                                dispatch(updateFields({
                                    name:val
                                }))
                            } }
                            value={_.get(state,"state.name","")}
                        />
                        <input
                            type="number"
                            placeholder="Phone Number"
                            className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onChange={(e)=> { 
                                let val = e.target.value
                                dispatch(updateFields({phone_number:val}))
                            }}
                            value={_.get(state,"state.phone_number","")}
                        />

                        <input
                            type="email"
                            placeholder="Email Address"
                            className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onChange={(e)=> { 
                                let val = e.target.value
                                dispatch(updateFields({email:val}))
                            }}
                            value={_.get(state,"state.email","")}
                        />

                        <input
                            type="text"
                            placeholder="Subject"
                            className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onChange={(e)=> { 
                                let val = e.target.value
                                dispatch(updateFields({subject:val}))
                            }}
                            value={_.get(state,"state.subject","")}
                        />

                        <textarea
                            rows="4"
                            placeholder="Your Message"
                            className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onChange={(e) => { 
                                let val = e.target.value
                                dispatch(updateFields({message:val}))
                            }}
                            value={_.get(state,"state.message","")}
                        />

                        <button
                            type="submit"
                            className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
                        >
                            Send Message
                        </button>
                    </form>
                </div>
            </div>
            {
                (
                    connectUsState.isLoading
                ) && (
                    <Loader show={true} />
                )
            }
        </div>
    )
}

const ContactItem = ({ title, value }) => (
    <div className="flex items-start gap-4 bg-white shadow-md rounded-lg p-4 mb-4">
        <div className="w-10 h-10 flex items-center justify-center bg-blue-600 text-white rounded-md font-bold">
            {title[0]}
        </div>
        <div>
            <p className="font-semibold">{title}</p>
            <p className="text-gray-600">{value}</p>
        </div>
    </div>
);

export default ConnectWithUs
